// LIGHTPAY-REFUND-HISTORY-UI-1 · 카드 승인·전액취소·부분취소 이력 (GET /seller/payments/card/transactions 조회 전용).
import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import api from '@/lib/api';

const won = (n) => `${(Number(n) || 0).toLocaleString('ko-KR')}원`;
const dt = (v) => { try { return v ? format(new Date(v), 'yyyy-MM-dd HH:mm') : '-'; } catch { return '-'; } };
const PS = { paid: '결제완료', partially_refunded: '부분환불', refunded: '전액환불' };
const ST = { succeeded: 'PG 취소 성공', failed: 'PG 취소 실패', uncertain: '결과 확인 필요', requested: '처리 중', rejected_concurrent: '중복 요청 거부' };

export const CancelHistory = ({ row }) => (
  <div className="space-y-2" data-testid={`refund-history-${row.seller_order_id}`}>
    <div className="grid grid-cols-3 gap-2 text-[11px]">
      <p>최초 승인 <b className="block text-sm" data-testid="rh-approved">{won(row.approved_amount)}</b></p>
      <p>누적 환불 <b className="block text-sm text-[#FF3B30]" data-testid="rh-refunded">{won(row.refunded_amount)}</b></p>
      <p>남은 결제 <b className="block text-sm" data-testid="rh-remaining">{won(row.remaining)}</b></p>
    </div>
    {row.cancels.length === 0 ? <p className="text-[11px] text-gray-400">취소 이력 없음</p> : row.cancels.map((c, i) => (
      <div key={c.cancel_id} className="rounded-md border border-black/10 dark:border-white/10 p-2 text-[11px]" data-testid={`rh-cancel-${i}`}>
        <div className="flex flex-wrap items-center gap-1.5">
          <b>{i + 1}회차</b>
          <span className="px-1.5 rounded bg-black/5 dark:bg-white/10" data-testid={`rh-type-${i}`}>{c.type === 'partial' ? '부분취소' : '전액취소'}</span>
          <span className={c.status === 'succeeded' ? 'text-emerald-700' : 'text-[#FF3B30]'} data-testid={`rh-status-${i}`}>
            {c.source === 'admin_confirm' ? '관리자 확인(공급사 화면)' : (ST[c.status] || c.status)}
          </span>
          <span className="ml-auto font-black" data-testid={`rh-amount-${i}`}>-{won(c.amount)}</span>
        </div>
        <p className="text-gray-500 mt-0.5">{c.source === 'admin_confirm' ? `공급사 취소 ${c.supplier_cancelled_at || '-'} · 기록 ${dt(c.at)}` : dt(c.at)}
          {c.cumulative != null && ` · 누적 ${won(c.cumulative)} · 남은 ${won(c.remaining_after)}`}</p>
        {c.lines.map((ln, j) => (
          <p key={j} className="text-gray-600 dark:text-gray-300" data-testid={`rh-line-${i}-${j}`}>
            · {ln.name}{Object.keys(ln.option || {}).length ? ` (${Object.values(ln.option).join('/')})` : ''}{ln.sku ? ` · SKU ${ln.sku}` : ''}
            {' '}· 취소 {ln.quantity}개 · {won(ln.refund)}{ln.remaining_qty != null ? ` · 남은 수량 ${ln.remaining_qty}개` : ''}
          </p>
        ))}
      </div>
    ))}
  </div>
);

export const OrderRefundHistory = ({ sellerOrderId }) => {
  const [row, setRow] = useState(null);
  useEffect(() => {
    api.get('/seller/payments/card/transactions', { params: { seller_order_id: sellerOrderId } })
      .then((r) => setRow((r.data.items || [])[0] || null)).catch(() => setRow(null));
  }, [sellerOrderId]);
  if (!row || !row.cancels.length) return null;
  return (
    <div className="rounded-lg border border-black/10 dark:border-white/10 p-3" data-testid="uod-refund-history">
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2">카드 취소·환불 이력</p>
      <CancelHistory row={row} />
    </div>
  );
};

const FILTERS = [['', '전체'], ['any', '취소·환불'], ['partial', '부분환불'], ['full', '전액환불']];

export const CardTransactionsPanel = ({ onOpenOrder, defaultFilter = '' }) => {
  const [f, setF] = useState(defaultFilter);
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get('/seller/payments/card/transactions', { params: f ? { refund: f } : {} }).then((r) => setD(r.data)).catch(() => setD({ items: [], counts: {} }));
  }, [f]);
  const cnt = d?.counts || {};
  const n = { any: (cnt.partially_refunded || 0) + (cnt.refunded || 0), partial: cnt.partially_refunded || 0, full: cnt.refunded || 0 };
  return (
    <div className="space-y-2" data-testid="card-tx-panel">
      <div className="flex flex-wrap gap-1.5">
        {FILTERS.map(([k, l]) => (
          <button key={k || 'all'} type="button" onClick={() => setF(k)} data-testid={`card-tx-filter-${k || 'all'}`}
            className={`px-2.5 py-1 rounded-full text-[11px] font-bold border ${f === k ? 'border-[#FF3B30] bg-[#FF3B30]/10 text-[#FF3B30]' : 'border-black/10 dark:border-white/10'}`}>
            {l}{k && <span className="ml-1 tabular-nums" data-testid={`card-tx-count-${k}`}>{n[k]}</span>}
          </button>
        ))}
      </div>
      {!d ? <p className="text-xs text-gray-400">불러오는 중…</p> : d.items.length === 0 ? <p className="text-xs text-gray-400" data-testid="card-tx-empty">해당 거래가 없습니다.</p> : d.items.map((r) => (
        <div key={r.seller_order_id} className="rounded-lg border border-black/10 dark:border-white/10 p-3" data-testid={`card-tx-row-${r.seller_order_id}`}>
          <button type="button" onClick={() => setOpen(open === r.seller_order_id ? null : r.seller_order_id)} className="w-full text-left" data-testid={`card-tx-toggle-${r.seller_order_id}`}>
            <div className="flex flex-wrap items-center gap-1.5 text-xs">
              <b className="font-mono">{r.order_number}</b>
              <span className="px-1.5 rounded bg-black/5 dark:bg-white/10">{PS[r.payment_status] || r.payment_status}</span>
              <span className="text-gray-500">카드 승인 {dt(r.approved_at)}</span>
              <span className="ml-auto font-black">{won(r.approved_amount)}</span>
            </div>
            <p className="text-[11px] text-gray-500 mt-0.5">환불 {won(r.refunded_amount)} · 남은 {won(r.remaining)} · 취소 {r.cancels.length}건</p>
          </button>
          {open === r.seller_order_id && (
            <div className="mt-2 space-y-2">
              <CancelHistory row={r} />
              {onOpenOrder && <button type="button" onClick={() => onOpenOrder(r.seller_order_id)} className="text-[11px] font-bold text-[#FF3B30] underline" data-testid={`card-tx-open-${r.seller_order_id}`}>주문 상세 열기</button>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CardTransactionsPanel;
